const data = {
  products: [
    {
      id: 1,
      title: 'ATLAS',
      img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/2020-11-2421-23-38_B_Radius11_Smoothing3_348x.png?v=1617210751',
      price: 595.99, 
      info: 'The Atlas is designed as an over-engineered tool watch. Legible dial with generously applied SuperLumiNova BGW9. Powered by the durable SII NE15 (6r15) automatic movement, known to run for years problem free. All housed in a custom 316L stainless steel case water resistant to 200m, designed for those who work in dynamic environments.',
      inCart: false,
      amount: 1,
      
    },

    {
      id: 2,
      title: 'OVERLORD',
      img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/PROFESSIONALSEABLUEFRONT_B_Radius11_Smoothing3_348x.png?v=1617215390',
      price: 469.99, 
      info: 'We started the Overlord project with a simple question. What if members of the Allied assault forces during World War II designed the field watch they wore into battle? We took that question and asked it to roughly 70 members of the Airborne community. Over the course of 90 weeks from start to finish, we came up with what you see here. The Overlord field watch (Airborne version requires proof of military jump course completion ).',
      inCart: false,
      amount: 1,
      
    },

    {
      id: 3,
      title: 'PROFESSIONAL',
      img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/NEPTUNEBRUSHEDMAINFRONT_B_Radius14_Smoothing3_348x.png?v=1617224167',
      price: 649.99, 
      info: 'The Professional was the initial prototype of the Kinetic II. As much as we loved the style of the Professional, the plan was to build a pilot\'s watch that could track three timezones. So we went back to work and made the Kinetic II. While we built the Kinetic II, the Professional prototypes were in the hands of friends being put to the test. The Professional was put to work as a test-bed for the Swiss Ronda movement that went into our Kinetic II in order to see the kind of abuse they could handle.',
      inCart: false,
      amount: 1,
      
    },

    {
      id: 4,
      title: 'KINETIC II',
      img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/2021-06-2813-37-38_B_Radius14_Smoothing3_590x.png?v=1625080296',
      price: 559.99, 
      info: 'Welcome back the Kinetic. We took the feedback from our tribe over the last few years and took the input of over forty pilots and aircrew (thanks gents!) on what everyone needed in a watch. We went to work in a long prototype phase. Making multiple prototypes until we felt we got the Kinetic II just right. Then, off the prototypes went. SE Asia, Europe, peaks in Switzerland, with buddies in Central Asia, Northern Africa, and M&A Consultants who go to work with a go-bag, unsure of where they might be in the afternoon. We took the feedback and made a few changes, resulting in the Kinetic II Expedition and Kinetic II Pilot. Designed for those who are always on the go, tracking multiple timezones.',
      inCart: false,
      amount: 1,
      
    },

    {
      id: 5,
      title: 'NEPTUNE',
      img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/NEPTUNEBRUSHEDMAINFRONT_B_Radius14_Smoothing3_348x.png?v=1617224167',
      price: 695.99, 
      info: 'When it came to designing the NEPTUNE, we wanted people to feel confident in the reliability of our dive watch. NEPTUNE is the result from two years of development, prototyping and testing. We had experienced divers and engineers from the special operations community and MIT fielding NEPTUNE, resulting in multiple revisions and iterations on the texture of the crown, crown guard, spring-bars and bezel insert materials. We tested a multitude of bezels to ensure that it’s seal is tight, but loose enough to allow subsurface manipulation with gloves. Once the prototype was finalized the real-world testing began.',
      inCart: false,
      amount: 1,
     
    },

    {
      id: 6,
      title: 'DARK MERLIN',
      img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/DARKMERLINFRONTMAIN2_B_Radius14_Smoothing3_348x.png?v=1617257324',
      price: 519.99, 
      info: 'As many of you know, we take great pride in "over testing" our timepieces, and after testing not 1, but 4 different prototypes, we happily to present to you The Merlin. Our first Solar Powered watch that is classically styled with a clean finish. The DLC coating adds a sleek take on this unconventional timepiece. The goal with all of our wristwatches is the same, to have a timepiece that can be used in both wetsuit and business suit. Allowing our watches to be With You from the office to the adventures. At the same time, we wanted something that would meet the feedback from our community. A wristwatch that would tick away and not need winding. Truly a grab-and-go.',
      inCart: false,
      amount: 1,
     
    },
  ],
}
export default data;

// export const detailProduct = {
//   id: 1,
//   title: 'ATLAS',
//   img: 'https://cdn.shopify.com/s/files/1/2293/1277/products/ScreenShot2020-09-14at12.55.20PM_720x.png?v=1610542330',
//   price: 595,
//   info: 'The Atlas is designed as an over-engineered tool watch. Legible dial with generously applied SuperLumiNova BGW9. Powered by the durable SII NE15 (6r15) automatic movement, known to run for years problem free. All housed in a custom 316L stainless steel case water resistant to 200m, designed for those who work in dynamic environments.',
//   inCart: false,
//   count: 0,
//   total: 0
// }

